
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/will/signup",
      function () {
        return require("private-next-pages/will/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/will/signup"])
      });
    }
  